import { render, staticRenderFns } from "./TitleAttributeField.vue?vue&type=template&id=27a92779&"
import script from "./TitleAttributeField.vue?vue&type=script&lang=ts&"
export * from "./TitleAttributeField.vue?vue&type=script&lang=ts&"
import style0 from "./TitleAttributeField.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports